import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InboxIcon from '@mui/icons-material/Inbox';

export const EmptyAPState = () => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      border: '1px dashed',
      borderColor: 'grey.300',
      borderRadius: 2,
      py: 4,
      px: 3,
      textAlign: 'center',
      color: 'text.secondary',
    }}
  >
    <InboxIcon sx={{ fontSize: 32, color: 'text.disabled', mb: 0.5 }} />
    <Typography sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
      No remit / payment data available
    </Typography>
    <Typography variant="body2">
      This week has no FedEx accounts payable items yet.
    </Typography>
  </Box>
);
